import { useGetOrganisationRelationshipsQuery } from "redux/services/membership";
import { GetOrganisationRelationshipsResponse } from "redux/services/membership/types";

type OrgRelItem = GetOrganisationRelationshipsResponse["data"][number];

interface UseAllOrgRelationshipsParams {
  executorOrgId: string;
  process: string;
  role: string;
  skip?: boolean;
}

interface UseAllOrgRelationshipsResult {
  data: OrgRelItem[];
  isFetching: boolean;
}

/**
 * Fetches org-relationships with a high pageSize so all BUs are returned in one call.
 * Uses RTK Query directly — caches by args, fires once, no loop risk.
 */
export const useAllOrgRelationships = ({
  executorOrgId,
  process,
  role,
  skip = false,
}: UseAllOrgRelationshipsParams): UseAllOrgRelationshipsResult => {
  const { data, isFetching } = useGetOrganisationRelationshipsQuery(
    {
      executorOrgId,
      process,
      role,
      pageNumber: 1,
      pageSize: 500,
    },
    { skip: skip || !executorOrgId }
  );

  return {
    data: data?.data ?? [],
    isFetching,
  };
};
